export default {}

document.addEventListener('usos-ui:lockScroll', _evt =>{
    document.documentElement.style.overflow = 'hidden';
});

document.addEventListener('usos-ui:unlockScroll', _evt => {
    document.documentElement.style.overflow = '';
});

declare global {
    interface HTMLElementEventMap {
        /** if single is true then only closest container should respond */
        'usos-ui:lockScroll': CustomEvent<{single: boolean}>,
        /** if single is true then only closest container should respond */
        'usos-ui:unlockScroll': CustomEvent<{single: boolean}>,
    }
}